import {useCallback, useEffect, useState} from 'react';
import {track} from '../services/analytics';

export const BAY_SESSION_PROJECTION_RESTORE_TIMEOUT_MS = 60_000;

type Options = {
  enabled: boolean, credentialReady: boolean, isBaySession: boolean, projectionReady: boolean,
  retryProjection: () => void, timeoutMs?: number
};

const useBaySessionProjectionRestore = (props: Options) => {
  const {
    enabled, credentialReady, isBaySession, projectionReady, timeoutMs = BAY_SESSION_PROJECTION_RESTORE_TIMEOUT_MS
  } = props;
  const [retryAttempt, setRetryAttempt] = useState(0);
  const [timedOut, setTimedOut] = useState(false);
  const isRestoring = enabled && isBaySession && credentialReady && !projectionReady;

  useEffect(() => {
    if (!isRestoring) {
      setTimedOut(false);
      return;
    }

    setTimedOut(false);
    const timeout = setTimeout(() => {
      setTimedOut(true);
      track('Bay Session Projection Restore Timed Out', {retryAttempt});
    }, timeoutMs);

    return () => clearTimeout(timeout);
  }, [isRestoring, retryAttempt, timeoutMs]);

  const retry = useCallback(() => {
    setTimedOut(false);
    setRetryAttempt(current => current + 1);
    props.retryProjection();
  }, [props.retryProjection]);

  return {isRestoring, retry, timedOut};
};

export default useBaySessionProjectionRestore;
